import { gql } from "@apollo/client";

const UpdateUserPresentationDecisionMutation = gql`
  mutation UpdateUserPresentationDecisionMutation(
    $presentationId: String!
    $decision: Boolean!
    $motivation: String
    $suggestedTimes: [Date!]
  ) {
    updateUserPresentationDecision(
      presentationId: $presentationId
      decision: $decision
      motivation: $motivation
      suggestedTimes: $suggestedTimes
    )
  }
`;

export default UpdateUserPresentationDecisionMutation; 
